import React, { Fragment } from "react";
import { Card, Stack, Typography } from "@mui/material";
import { stripBaseUrl, withHTTP } from "../../../../helpers/stringHelper";
import { useTheme } from "@emotion/react";
import { Link } from "@phosphor-icons/react";
import { CATEGORY_ICONS } from "../../../../enums/iconsEnums";

export const LinksCard = ({ value, icon }) => {
  const theme = useTheme();
  const renderIcon = CATEGORY_ICONS?.[icon] ?? null;
  const linkValue = withHTTP(value) ? value : `https://${value}`;
  return (
    <Fragment>
      {value && <Card variant="outlined" sx={{ border: '2px solid #F9FAFB', padding: '16px 16px', cursor: 'pointer' }} onClick={() => window.open(linkValue, '_blank')}>
        <Stack direction={'row'} alignItems={'center'} gap={2}>
          {renderIcon ? <img src={renderIcon} /> : <Link size={20} />}
          <Typography sx={{ width: 270 }} noWrap>
            {stripBaseUrl(value) && <span style={{ color: theme.palette.grey.light }}> {stripBaseUrl(value)}/</span>}
            {value?.split('/').pop()}
          </Typography>
        </Stack>
      </Card>}
    </Fragment>
  );
};